export const FETCH_PAYMENT_ORDER_DETAIL_PENDING =
  'FETCH_PAYMENT_ORDER_DETAIL_PENDING';
export const FETCH_PAYMENT_ORDER_DETAIL_REJECTED =
  'FETCH_PAYMENT_ORDER_DETAIL_REJECTED';
export const FETCH_PAYMENT_ORDER_DETAIL_FULFILLED =
  'FETCH_PAYMENT_ORDER_DETAIL_FULFILLED';
export const CLEAR_FETCH_PAYMENT_ORDER_DETAIL =
  'CLEAR_FETCH_PAYMENT_ORDER_DETAIL';



// WEBPACK FOOTER //
// ./src/constants/paymentOrderDetail.js